export default __webpack_public_path__ + "static/media/Bucket-Cart.6eee8cbb.svg";